import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TycComponent } from 'src/app/modules/shared/components/dialogs/tyc/tyc.component';
import errors from '../../../pages/auth/utils/errorCodes';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class AuthUtilsService {
  public actualYear: number = new Date().getFullYear();
  constructor(private dialog: MatDialog) {}

  public getErrorMessage(controlErrors: { [error: string]: string }): string {
    const keys = Object.keys(controlErrors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  touchControls(form: FormGroup): void {
    Object.keys(form.controls).forEach((control: string) => {
      form.controls[control].markAsDirty();
      form.controls[control].markAsTouched();
    });
  }

  openTyc() {
    this.dialog.open(TycComponent, {
      panelClass: 'modal-tyc',
    });
  }

  openPrivacy() {
    this.dialog.open(TycComponent, {
      panelClass: 'modal-tyc',
      backdropClass: 'modal-background',
      maxWidth: '600px',
      data: {
        type: 'privacy',
      },
    });
  }
}
